import React, { useState } from 'react';

import useNavigateToPage from '@/hooks/useNavigateToPage';
import Button from '@/ui/components/Button';
import InputField from '@/ui/components/Form/InputField';

const ClaimLookup = () => {
  const [claimId, setClaimId] = useState('');
  const { navigateToCms1500 } = useNavigateToPage();

  const handleLookup = () => {
    if (claimId) {
      navigateToCms1500(claimId);
    }
  };
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleLookup();
      }}>
      <div className="flex text-sm">
        <InputField
          type="text"
          id="claimId"
          value={claimId}
          label={'Claim ID'}
          placeholder="eg. 123"
          onChange={(e) => setClaimId(e.target.value)}
        />
        <div className="flex items-end m-1">
          <Button className="ml-2" type="submit">
            Lookup
          </Button>
        </div>
      </div>
    </form>
  );
};
export default React.memo(ClaimLookup);
